import { render, staticRenderFns } from "./InviteResourceIcon.vue?vue&type=template&id=ad93693c"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad93693c')) {
      api.createRecord('ad93693c', component.options)
    } else {
      api.reload('ad93693c', component.options)
    }
    module.hot.accept("./InviteResourceIcon.vue?vue&type=template&id=ad93693c", function () {
      api.rerender('ad93693c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/paymentV2/InviteResourceIcon.vue"
export default component.exports